// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/auth/v1/audit.proto (package chalk.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/auth/v1/audit.proto.
 */
export const file_chalk_auth_v1_audit: GenFile = /*@__PURE__*/
  fileDesc("ChljaGFsay9hdXRoL3YxL2F1ZGl0LnByb3RvEg1jaGFsay5hdXRoLnYxIk0KDEF1ZGl0T3B0aW9ucxIoCgVsZXZlbBgBIAEoDjIZLmNoYWxrLmF1dGgudjEuQXVkaXRMZXZlbBITCgtkZXNjcmlwdGlvbhgCIAEoCSpWCgpBdWRpdExldmVsEhsKF0FVRElUX0xFVkVMX1VOU1BFQ0lGSUVEEAASFgoSQVVESVRfTEVWRUxfRVJST1JTEAESEwoPQVVESVRfTEVWRUxfQUxMEAI6VgoFYXVkaXQSHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxix6gEgASgLMhsuY2hhbGsuYXV0aC52MS5BdWRpdE9wdGlvbnNSBWF1ZGl0iAEBQhBaDmF1dGgvdjE7YXV0aHYxYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * @generated from message chalk.auth.v1.AuditOptions
 */
export type AuditOptions = Message<"chalk.auth.v1.AuditOptions"> & {
  /**
   * @generated from field: chalk.auth.v1.AuditLevel level = 1;
   */
  level: AuditLevel;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message chalk.auth.v1.AuditOptions.
 * Use `create(AuditOptionsSchema)` to create a new message.
 */
export const AuditOptionsSchema: GenMessage<AuditOptions> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_audit, 0);

/**
 * @generated from enum chalk.auth.v1.AuditLevel
 */
export enum AuditLevel {
  /**
   * @generated from enum value: AUDIT_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUDIT_LEVEL_ERRORS = 1;
   */
  ERRORS = 1,

  /**
   * @generated from enum value: AUDIT_LEVEL_ALL = 2;
   */
  ALL = 2,
}

/**
 * Describes the enum chalk.auth.v1.AuditLevel.
 */
export const AuditLevelSchema: GenEnum<AuditLevel> = /*@__PURE__*/
  enumDesc(file_chalk_auth_v1_audit, 0);

/**
 * @generated from extension: optional chalk.auth.v1.AuditOptions audit = 30001;
 */
export const audit: GenExtension<MethodOptions, AuditOptions> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_audit, 0);

